import { action } from 'typesafe-actions';
import ActionTypes from './constants';

export const sendIdentify = () => action(ActionTypes.SEND_IDENTIDY);
